import React from 'react';
import CreateType from './Types/TypeForm'
import CreateTypeHierarchy from './Types/TypeHierarchy'
import ListTypes from './Types/ListType'
import CreateCadmin from './../FormController/C_Admin/CreateCadmin'
import ListCadmin from './../FormController/C_Admin/ListCAdmin'
import CreateSadmin from './../FormController/S_Admin/CreateSadmin'
import ListSadmin from './../FormController/S_Admin/ListSAdmin'
import CreateUsers from './../FormController/CreateUser/CreateUser'
import ListUsers from './../FormController/CreateUser/ListUser'
import ListUsersSiteAdminReport from './../FormController/Reports/listUsersSiteAdminReport'
import AlignedWorkflowSiteAdmin from './../FormController/Reports/alignedWorkflowToSiteAdmin'
import AlignedWorkSessionSiteAdmin from './../FormController/Reports/alignedSessionSiteAdmin'
import ReportWorkflowSiteAdmin from './../FormController/Reports/ReportWorkflowSiteAdmin'
import EditUsers from './../FormController/CreateUser/EditUser'
import AcessDenied from './../FormController/SplashPage/AcessDenied'
import CreateWorkflow from './Workflow/WorkflowList'
import WorkflowVersionList from './Workflow/VersionListWorkflow'
import CreateTask from './Workflow/CreateTasks'
import PublishedTask from './Workflow/PublishedTask'
import ListMcqBank from './Banks/ListMcq'
import CreateMcqBank from './Banks/CreateMcqBank'
import EditMcqBank from './Banks/EditMcqBank'
import ListRangeBank from './Banks/ListRange'
import CreateRangeBank from './Banks/CreateRangeBank'
import EditRangeBank from './Banks/EditRangeBank'
import ListParentChildBank from './Banks/ListParentChild'
import CreateParentChildBank from './Banks/CreateParentChildBank'
import AlignedWorkflow from './Workflow/AlignedWorkflow'
import ReportWorkflow from './Workflow/ReportWorkflow'
import AlignedWorkflowReport from './Workflow/AlignedWorkflowReport'
import ListSop from './SOP/ListSop'
import CreateSop from './SOP/CreateSOP'
import UserProfile from './Profile/UserProfile'
import SiteProfile from './Profile/SiteProfile'
import CorporateProfile from './Profile/CorporateProfile'
import ChangePassword from './Profile/ChangePassword'
import TrashForm from './Trash/TrashForm'
import ContactList from './Profile/ContactList'
import VideoChat from './VideoChat/videochat'
import Chat from './VideoChat/Chat'
import { ud } from '../Server'
import Videogrid from './VideoChat/videogrid'
import CallInitiation from './VideoChat/CallManager';
import CallStastistics from './CallStastistics/callStastistics';
import VideoCallStatictics from './CallStastistics/VideoCallStatictics';
import ListLocation from './Locations/ListLocations';
import CreateLocation from './Locations/CreateLocations';
import CorporateLogo from './Profile/CorporateLogo';
import UserListAccordingSite from './C_Admin/UserListAccordingSite';
import ViewUser from './CreateUser/ViewUser';
import TypeHierarchyCAdmin from './Types/TypeHierarchyCAdmin';
import WorkflowListSAdmin from './Workflow/WorkflowListSAdmin';
import SiteProfileCadmin from './Profile/SiteProfileCadmin';
import ListLicense from './C_Admin/ListLicense';
import Config from './Config/ConfigCreate';
import FAQMain from '../FAQ/FAQMain';
import { Audiocall } from './VideoChat/Call';


class FormController extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {
        if (ud) {
                switch (this.props.match.params.formtype) {
                    case "sadmin":
                        return <CreateSadmin />;

                    case "listsadmin":
                        return <ListSadmin />;

                    case "changepassword":
                        return <ChangePassword />;

                    case "listlocation":
                        return <ListLocation />;

                    case "createlocation":
                        return <CreateLocation />;

                    case "profile":
                        return <CorporateProfile />;

                    case "siteprofile":
                        return <SiteProfileCadmin />;

                    case "corporatelogo":
                        return <CorporateLogo />;

                    case "user_info":
                        return <ViewUser />;

                    case "listuser_cadmin":
                        return <UserListAccordingSite />;

                    case "typehierarchycadmin":
                        return <TypeHierarchyCAdmin />;

                    case "listworkflow_cadmin":
                        return <WorkflowListSAdmin />;

                    case "cadmin":
                        return <CreateCadmin />;

                    case "listcadmin":
                        return <ListCadmin />;

                    case "listlicense":
                        return <ListLicense />;

                    case "type":
                        return <CreateType />;

                    case "listtypes":
                        return <ListTypes />;

                    case "typehierarchy":
                        return <CreateTypeHierarchy />;

                    case "user":
                        return <CreateUsers />;

                    case "listuser":
                        return <ListUsers />;

                    case "userlistreport":
                        return <ListUsersSiteAdminReport />;

                    case "alignedworkflowsiteadmin":
                        return <AlignedWorkflowSiteAdmin />;

                    case "alignedsessionsiteadmin":
                        return <AlignedWorkSessionSiteAdmin />;

                    case "reportworkflowsiteadmin":
                        return <ReportWorkflowSiteAdmin />;

                    case "edituser":
                        return <EditUsers />;

                    case "workflow":
                        return <CreateWorkflow />;

                    case "workflowversionlist":
                        return <WorkflowVersionList />;

                    case "mcqbanklist":
                        return <ListMcqBank />;

                    case "mcqbankcreate":
                        return <CreateMcqBank />;

                    case "mcqbankedit":
                        return <EditMcqBank />;

                    case "rangebanklist":
                        return <ListRangeBank />;

                    case "rangebankcreate":
                        return <CreateRangeBank />;

                    case "rangebankedit":
                        return <EditRangeBank />;

                    case "parentchildbanklist":
                        return <ListParentChildBank />;

                    case "parentchildbankcreate":
                        return <CreateParentChildBank />;

                    case "task":
                        return <CreateTask />;

                    case "publishedtask":
                        return <PublishedTask />;

                    case "listsop":
                        return <ListSop />;

                    case "createsop":
                        return <CreateSop />;

                    case "changepassword":
                        return <ChangePassword />;

                    case "trash":
                        return <TrashForm />;

                    case "profile":
                        return <SiteProfile />;

                    case "sadmin":
                        return <CreateSadmin />;

                    case "listsadmin":
                        return <ListSadmin />;

                    case "siteprofile":
                        return <SiteProfileCadmin />;

                    case "faq":
                        return <FAQMain />;

                    case "reportworkflow":
                        return <ReportWorkflow />;

                    case "alignedworkflow":
                        return <AlignedWorkflow />;

                    case "alignedworkflowsession":
                        return <AlignedWorkflowReport />;

                    case "profile":
                        return <UserProfile />;

                    case "changepassword":
                        return <ChangePassword />;

                    case "contectlist":
                        return <ContactList socket={this.props.socket} toCalling={this.props.toCalling} />;

                    case "videochat":
                        return <VideoChat />;

                    case "videogrid":
                        return <Videogrid />;

                    case "callroom":
                        return <CallInitiation />;

                    case "callstaistics":
                        return <CallStastistics />;

                    case "videocallstaistics":
                        return <VideoCallStatictics />;

                    case "chat":
                        return <Chat />;

                    case "faq":
                        return <FAQMain />;

                    case "cadmin":
                        return <CreateCadmin />;

                    case "listcadmin":
                        return <ListCadmin />;

                    case "listlicense":
                        return <ListLicense />;

                    case "listlocation":
                        return <ListLocation />;

                    case "createlocation":
                        return <CreateLocation />;

                    case "config":
                        return <Config />;
                    default:
                        return <AcessDenied />;
                }
            }
            else {
                return <div></div>
            }

        }
}

export default FormController

// this is test
// this is test 12